module.exports = __webpack_public_path__ + "assets/img/img94.a3150c88.png";